const PublicPage = () => {
  return (
    <div className="page">
      <h2>Public Page</h2>
      <p>Access Allowed to everyone!😄</p>
    </div>
  );
};

export default PublicPage;
